import React from 'react'
import { connect } from 'react-redux'
import ShareByEmailForm from './ShareByEmailForm'
import ShareThis, { ShareOption } from 'components/Vendor/ShareThis'
import LineEnvelopeIcon from 'components/Luxkit/Icons/line/LineEnvelopeIcon'
import { copyAvailable } from 'lib/web/clipboardUtils'
import { isLoggedIn } from 'selectors/accountSelectors'
import LineLinkIcon from 'components/Luxkit/Icons/line/LineLinkIcon'
import { EMAIL_MODE, ShareConfig } from './ShareModal'

interface Props {
  loggedIn?: boolean;
  shareConfig: ShareConfig;
  mailTo: string | undefined;
  onShare: (shareMethod: string, shareMethodKey?: string) => void;
  closeShareModal: () => void;
  copyToClipboard: () => void;
  mode?: typeof EMAIL_MODE;
  setMode?: React.Dispatch<React.SetStateAction<'email' | undefined>>
}

function ShareModalContentControl(props: Props) {
  const {
    shareConfig,
    loggedIn,
    mailTo,
    onShare,
    closeShareModal,
    copyToClipboard,
    mode,
    setMode,
  } = props

  const shareMessage = shareConfig.shareMessage || ''

  return <>
    {mode === EMAIL_MODE && (<ShareByEmailForm
          onShare={onShare}
          closeShareModal={closeShareModal}
          shareMessage={shareMessage}
          shareConfig={shareConfig}
        />)}
    {mode !== EMAIL_MODE && (
      <>
        <ShareOption
              kind="tertiary"
              href={mailTo}
              onClick={() => {
                loggedIn ? setMode?.(EMAIL_MODE) : onShare('email')
              }}
              startIcon={<LineEnvelopeIcon />}
            >
          Email
        </ShareOption>
        <ShareThis
              onShare={onShare}
              shareConfig={shareConfig}
            />
        {copyAvailable() && (<ShareOption kind="tertiary" onClick={copyToClipboard} startIcon={<LineLinkIcon />}>
          Copy link to clipboard
        </ShareOption>)}
      </>
    )}
  </>
}

function mapStateToProps(state: App.State) {
  return {
    loggedIn: isLoggedIn(state),
  }
}

export default connect(mapStateToProps)(ShareModalContentControl)
